module.exports = __webpack_public_path__ + "img/space-page-under-construction.cce5c778.png";